const tentativiChiamataDati = {Component:"Card",tipoChiamata:3, action:"Dashboard/GetMediaTentativiChiamate", method:"post"}

const durataMediaChiamateDati  = {Component:"Card",tipoChiamata:null,action:"Dashboard/GetDurataMediaChiamate",method:"post"}

const durataMediaEffettuateDati  =  {Component:"Card",tipoChiamata:2,action:"Dashboard/GetDurataMediaChiamate",method:"post"}

const durataMediaRicevuteDati  = {Component:"Card",tipoChiamata:1, action:"Dashboard/GetDurataMediaChiamate",method:"post"}

const riepilogativoTentativiMediaChiamate = {Componet:"Card", tipoChiamata:[2,3], action:"Dashboard/GetRiepilogoTentativiMediaChiamate", method:"post"}

const countChiamate  = {Component:"Chart",tipoChiamata:[1,2,3], action:"Dashboard/GetDatiChiamate",method:"post"}

const getDurataChiamate =  {Component:"Chart", tipoChiamata:[1,2], action:"Dashboard/GetDurataChiamate", method:"post"}

const getDeviceChiamataEffettuate =  {Component:"Chart", tipoChiamata:[2], action:"Dashboard/GetDeviceChiamateEffettuate", method:"post"}

const getDispositivi = {Component:"FilterPanel",action:"Device/GetDispositivi", method:"get"}

const getDispositivisPaginated = {Componet:"CallsLogDatatable", action:"Device/GetDispositiviDataTable", method:"post"}

const getCallsLogPaginated = {Componet:"CallsLogDatatable", action:"Chiamata/GetChiamateDataTable", method:"post"}

const getUsersPaginated = { Component: "UsersDatatable", action: "Utente/GetUsersDataTable", method: "post" }

const getCallTypes = {Component:"FilterPanelDatatable, App", action:"TipoChiamata/GetTipoChiamate", method:"get"}

const exportCallsLog = { action:"Chiamata/ExportChiamate", method:"post"}

const exportDevices = { action:"Device/ExportDispositivo", method:"post"}

const exportUsers = { action: "Utente/ExportUsers", method: "post" }

const changeDevices = {action:"Device/AddEditDispositivo", method:"post"}

const getDispositiviById = {action:"Device/GetDispositivoById?id=", method:"get"}

const loginUtente = {action:"Account/Login", method:"post"}

const cambioPsw = {action: "Account/CambioPassword", method:"post"}

const getUserById = { action:"Utente/GetUserById?id=", method:"get"}

const addUser = {action: "Utente/AddUser", method:"post"}

const editUser = {action: "Utente/EditUser", method:"post"}

const deleteRestoreUser = {action: "Utente/DeleteRestoreUser", method:"post"}

const getUserRoles = {action: "Ruolo/GetRoles", method:"get"}

const resetPasswordUser = {action: "Utente/ResetPassword", method:"post"}

const EnableDisableDispositivo = {action: "Device/EnableDisableDispositivo", method:"post"}

export  {
    EnableDisableDispositivo,
    deleteRestoreUser,
    cambioPsw,
    loginUtente,
    tentativiChiamataDati,
    durataMediaChiamateDati,
    durataMediaEffettuateDati,
    durataMediaRicevuteDati,
    riepilogativoTentativiMediaChiamate,
    countChiamate,
    getDispositivi,
    getDurataChiamate,
    getDeviceChiamataEffettuate,
    getCallsLogPaginated,
    getUsersPaginated,
    getDispositivisPaginated,
    getCallTypes,
    exportCallsLog,
    exportDevices,
    changeDevices,
    getDispositiviById,
    exportUsers,
    getUserById,
    addUser,
    editUser,
    resetPasswordUser,
    getUserRoles
};
